export default __webpack_public_path__ + "static/media/banner1.a6ecfd72.png";